import { isString } from 'lodash-es';

export const isAccount = id => isString(id) && id.startsWith('001');
export const isLead = id => isString(id) && id.startsWith('00Q');
export const isContact = id => isString(id) && id.startsWith('003');
export const isOpportunity = id => isString(id) && id.startsWith('006');
export const isCampaign = id => isString(id) && id.startsWith('701');
export const isLeadOrContact = id =>
  isString(id) && (id.startsWith('00Q') || id.startsWith('003'));
